// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

/**
 * TOPページに関する処理
 */

const parent = document.querySelector('#js-top-page');

const swiperSlides = document.getElementsByClassName('swiper-container');
const breakPoint = 768;
let mySwiper;
let mySwiperBool;

window.addEventListener(
  'load',
  () => {
    if (!parent) return;
    if (breakPoint < window.innerWidth) {
      mySwiperBool = false;
    } else {
      createSwiper();
      mySwiperBool = true;
    }
  },
  false
);

window.addEventListener(
  'resize',
  () => {
    if (!parent) return;
    if (breakPoint < window.innerWidth && mySwiperBool) {
      mySwiper[0].destroy(false, true);
      mySwiper[1].destroy(false, true);
      mySwiperBool = false;
    } else if (breakPoint >= window.innerWidth && !mySwiperBool) {
      createSwiper();
      mySwiperBool = true;
    }
  },
  false
);

const createSwiper = () => {
  mySwiper = new Swiper('.swiper-container', {
    // speed: 1500,
    // autoplay: {
    //   delay: 2000
    // },
    // slideToClickedSlide: true,
    // spaceBetween: 10,
    // slidesPerView: 'auto',
    // loop: true,
    // loopedSlides: swiperSlides.length,
    // centeredSlides: true,
    // loop: true,
    // If we need pagination
    spaceBetween: 20,
    freeMode: true,
    freeModeSticky: true,
    //モジュールを使う
    modules: [Pagination],
    pagination: {
      el: '.swiper-pagination',
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

export default class PageTop {
  constructor(_parm) {
  }

  /**
   * メインビジュアルの記事のリンクhoverで属性付け外し
   */
  mvArticle() {
    const elmMvArticle = document.querySelector('#js-index-article-mv') ?? false;
    if (!elmMvArticle) return;
    const arryaElmsMvLink = [...elmMvArticle.querySelectorAll('a')];
    const attr = 'data-hover';
    arryaElmsMvLink.forEach(_elmLink => {
      _elmLink.addEventListener('mouseover', (_ev) => {
        elmMvArticle.setAttribute(attr, 'true');
      });
      _elmLink.addEventListener('mouseleave', (_ev) => {
        elmMvArticle.setAttribute(attr, 'false');
      });
    });

  }

  init() {
    this.mvArticle();
  }
}
